/* global initialPrice, utforandeBreddValues,  calculationType, taxRate */
/**
 * UI Manager Module
 * Manages UI elements, event listeners and displays
 */
const UIManager = (function () {
  let modules = {}
  let calculationDataJson = ''
  let priceElement

  function init(options) {
    modules = options
    priceElement = document.querySelector('.woocommerce-Price-amount')
    return this
  }

  function initialize() {
    setupEventListeners()
    updateInitialPrice()
    initializeCalculations()
    setupPriceObserver()
  }

  function updateInitialPrice() {
    const variationPriceContainer = document.querySelector('.woocommerce-variation-price')
    if (variationPriceContainer) {
      const basePrice = modules.priceCalculator.wholeKrona(initialPrice * taxRate) // These are global variables from WP
      const priceHtml = `
        <span class="price">
          <span class="woocommerce-Price-amount amount">
            ${modules.priceFormatter.format(basePrice)}
          </span>
          <small class="woocommerce-price-suffix"> ${modules.priceFormatter.suffix}</small>
        </span>`

      variationPriceContainer.innerHTML = priceHtml
      priceElement = variationPriceContainer.querySelector('.woocommerce-Price-amount')
    }
  }

  function setPriceLoading(loading) {
    const container = document.querySelector('.woocommerce-variation-price')
    if (!container) return
    container.style.opacity = loading ? '0.5' : ''
    container.setAttribute('aria-busy', loading ? 'true' : 'false')
  }

  function updatePrice() {
    priceElement = document.querySelector('.woocommerce-variation-price .woocommerce-Price-amount')
    if (!priceElement) {
      priceElement = document.querySelector('.woocommerce-Price-amount')
    }

    // Get form values
    const variationId = document.querySelector('.variation_id').value

    // WooCommerce clears the variation id while it looks up the new variation (AJAX for large variation sets).
    // Keep the previous price (dimmed) instead of showing 0 kr until the new variation is known.
    const knownVariation = modules.priceCalculator.hasVariation(variationId)
    setPriceLoading(!knownVariation)
    if (!knownVariation) return

    const selectedUtforande = getSelectedUtforande()

    const breddInput = document.getElementById('tillagg_bredd')
    const hojdInput = document.getElementById('tillagg_hojd')
    const totalHeightInput = document.getElementById('total_height_field')
    const transomField = document.getElementById('transom_height_field')
    const openingField = document.getElementById('opening_height_field')

    // Get values with safe fallbacks
    const bredd = breddInput ? parseInt(breddInput.value) || 0 : 0
    const hojd = hojdInput ? parseInt(hojdInput.value) || 0 : 0
    const totalHeight = totalHeightInput ? parseInt(totalHeightInput.value) || 0 : 0
    const overljus = transomField ? parseInt(transomField.value) || 0 : 0
    const opening = openingField ? parseInt(openingField.value) || 0 : 0

    // Update UI for bredd input if needed
    if (selectedUtforande && breddInput) {
      const breddValues = utforandeBreddValues[selectedUtforande] || { min: 0, max: 0 }
      updateBreddPlaceholder(breddInput, breddValues)
      modules.formValidator.validateBreddInput(breddInput, breddValues)
    }

    // Calculate price
    const priceData = modules.priceCalculator.calculateTotalPrice({
      variationId,
      selectedUtforande,
      bredd,
      hojd,
      totalHeight,
      opening,
      overljus
    })

    // Create price element if needed
    if (!priceElement) {
      createPriceElement()
    }

    // Update displayed price
    if (priceElement) {
      if (priceData.hasDiscount) {
        // Show both original (strikethrough) and discounted price
        priceElement.innerHTML = `<del>${modules.priceFormatter.format(priceData.originalPrice)}</del> <ins>${modules.priceFormatter.format(priceData.discountedPrice)}</ins>`
      } else {
        // Show only original price
        priceElement.innerHTML = modules.priceFormatter.format(priceData.originalPrice)
      }
    }

    // Store calculation data for form submission
    storeCalculationData({
      bredd,
      hojd,
      totalHeight,
      opening,
      overljus,
      calculationType, // Global variable from WP
      variationId,
      utforande: selectedUtforande
    })
  }

  function createPriceElement() {
    const variationPriceContainer = document.querySelector('.woocommerce-variation-price')
    if (variationPriceContainer) {
      const priceHtml = `
        <span class="price">
          <span class="woocommerce-Price-amount amount"></span>
          <small class="woocommerce-price-suffix"> ${modules.priceFormatter.suffix}</small>
        </span>`
      variationPriceContainer.innerHTML = priceHtml
      priceElement = variationPriceContainer.querySelector('.woocommerce-Price-amount')
    }
  }

  function getSelectedUtforande() {
    const selectedUtforande = document.querySelector('.variable-items-wrapper li.selected')
    if (selectedUtforande) {
      return selectedUtforande.getAttribute('data-value')
    }
    return null
  }

  function updateBreddPlaceholder(breddInput, breddValues) {
    breddInput.placeholder = 'Minst ' + breddValues.min + 'mm, Max ' + breddValues.max + 'mm'
    breddInput.min = breddValues.min
    breddInput.max = breddValues.max
  }

  function storeCalculationData(data) {
    calculationDataJson = JSON.stringify(data)
    setupFormSubmitHandler()
  }

  function setupFormSubmitHandler() {
    const cartForm = document.querySelector('form.cart')
    if (cartForm) {
      // Store original onsubmit handler if it exists
      const originalSubmit = cartForm.onsubmit

      // Replace with our custom handler
      cartForm.onsubmit = function (event) {
        // Create a temporary hidden field just before submission
        const hiddenField = document.createElement('input')
        hiddenField.type = 'hidden'
        hiddenField.name = 'price_calculation_data'
        hiddenField.value = calculationDataJson

        // Append to the form
        this.appendChild(hiddenField)

        // Call original handler if it existed
        if (typeof originalSubmit === 'function') {
          return originalSubmit.call(this, event)
        }
      }
    }
  }

  function updateAddToCartButtonState() {
    const breddInput = document.getElementById('tillagg_bredd')
    const addToCartButton = document.querySelector('.single_add_to_cart_button')

    if (!breddInput || !addToCartButton) return

    const selectedValue = getSelectedUtforande()
    const breddValues = utforandeBreddValues[selectedValue] || { min: 0, max: 0 }
    const isBreddValid = modules.formValidator.validateBreddInput(breddInput, breddValues)

    // Also check total height validity if needed
    let isTotalHeightValid = true
    if (calculationType === 'total_height') {
      const totalHeightField = document.getElementById('total_height_field')
      if (totalHeightField) {
        const totalHeight = parseFloat(totalHeightField.value) || 0
        isTotalHeightValid = modules.formValidator.validateTotalHeight(totalHeight)
      }
    }

    // Enable or disable button
    if (!isBreddValid || !isTotalHeightValid) {
      addToCartButton.setAttribute('disabled', 'disabled')
      addToCartButton.classList.add('disabled')
    } else {
      addToCartButton.removeAttribute('disabled')
      addToCartButton.classList.remove('disabled')
    }
  }

  function updateHeights() {
    const hojdInput = document.getElementById('tillagg_hojd')
    const totalHeightField = document.getElementById('total_height_field')
    const openingHeightField = document.getElementById('opening_height_field')
    const transomHeightField = document.getElementById('transom_height_field')

    if (!hojdInput || !totalHeightField) return

    const h1 = parseFloat(hojdInput.value)
    const h3 = parseFloat(totalHeightField.value)

    if (isNaN(h3)) return

    const heights = modules.heightCalculator.calculateHeights(h1, h3)

    // Update display fields
    openingHeightField.value = heights.opening + ' mm'
    transomHeightField.value = heights.transom + ' mm'

    // Update hidden fields
    document.getElementById('opening_height').value = heights.opening
    document.getElementById('transom_height').value = heights.transom
    document.getElementById('total_height').value = heights.total

    // Validate and update UI
    modules.formValidator.validateTotalHeight(h3)
    updateAddToCartButtonState()
    updatePrice()
  }

  function updateTotalHeight() {
    const hojdInput = document.getElementById('tillagg_hojd')
    const totalHeightField = document.getElementById('total_height_field')
    const totalHeightHiddenField = document.getElementById('total_height')

    if (!hojdInput || !totalHeightField) return

    const height = parseFloat(hojdInput.value) || 0
    const totalHeight = modules.heightCalculator.calculateTotalHeight(height)

    totalHeightField.value = totalHeight

    // Update hidden field
    if (totalHeightHiddenField) {
      totalHeightHiddenField.value = totalHeight
    }

    const breddInput = document.getElementById('tillagg_bredd')
    if (breddInput) {
      const selectedValue = getSelectedUtforande()
      const breddValues = utforandeBreddValues[selectedValue] || { min: 0, max: 0 }
      modules.formValidator.validateBreddInput(breddInput, breddValues)
    }

    updatePrice()
  }

  function updateSplitHeights() {
    const hojdInput = document.getElementById('tillagg_hojd')
    const totalHeightField = document.getElementById('total_height_field')
    const openingHeightField = document.getElementById('opening_height_field')
    const transomHeightField = document.getElementById('transom_height_field')

    if (!hojdInput || !totalHeightField) return

    const h1 = parseFloat(hojdInput.value)
    const h3 = parseFloat(totalHeightField.value)

    if (isNaN(h1) || isNaN(h3)) return

    const heights = modules.heightCalculator.calculateSplitHeights(h1, h3)

    // Update display fields
    openingHeightField.value = heights.opening + ' mm'
    transomHeightField.value = heights.transom + ' mm'

    // Update hidden fields
    document.getElementById('opening_height').value = heights.opening
    document.getElementById('transom_height').value = heights.transom
    document.getElementById('total_height').value = heights.total

    // Validate and update UI
    modules.formValidator.validateTotalHeight(h3)
    updateAddToCartButtonState()
    updatePrice()
  }

  function setupEventListeners() {
    // Setup variation change events
    const utforandeDropdown = document.querySelector('select[name="attribute_pa_utforande"]')
    if (utforandeDropdown) {
      utforandeDropdown.addEventListener('change', function () {
        const breddInput = document.getElementById('tillagg_bredd')
        const utforande = utforandeDropdown.value
        const breddValues = utforandeBreddValues[utforande] || { min: 0, max: 0 }

        updateBreddPlaceholder(breddInput, breddValues)
        updatePrice()
      })
    }

    // Setup utforande selection with the visual selector
    const utforandeContainer = document.querySelector(
      '.variable-items-wrapper[data-attribute_name="attribute_pa_utforande"]'
    )
    if (utforandeContainer) {
      utforandeContainer.addEventListener('click', function (event) {
        const selectedUtforande = event.target.closest('li')
        if (selectedUtforande) {
          setTimeout(updatePrice, 0)
        }
      })
    }

    // Setup height field listeners
    const tillaggHojd = document.getElementById('tillagg_hojd')
    const totalHeightField = document.getElementById('total_height_field')

    if (tillaggHojd) {
      tillaggHojd.addEventListener('change', function () {
        if (totalHeightField) {
          setInitialMinMax()
          updatePlaceholderAndValidate()
        }
        updatePrice()
      })

      if (calculationType === 'total_height') {
        tillaggHojd.addEventListener('input', updateTotalHeight)
      } else if (calculationType === 'opening_height') {
        tillaggHojd.addEventListener('input', updateHeights)
        tillaggHojd.addEventListener('change', updateHeights)
      } else if (calculationType === 'opening_height_split') {
        tillaggHojd.addEventListener('input', updateSplitHeights)
        tillaggHojd.addEventListener('change', updateSplitHeights)
      }
    }

    if (totalHeightField) {
      totalHeightField.addEventListener('input', function () {
        if (calculationType === 'opening_height') {
          updateHeights()
        } else if (calculationType === 'opening_height_split') {
          updateSplitHeights()
        }
        updatePlaceholderAndValidate()
        updatePrice()
      })
    }

    // Setup bredd input listeners
    const breddInput = document.getElementById('tillagg_bredd')
    if (breddInput) {
      breddInput.addEventListener('input', function () {
        const selectedValue = getSelectedUtforande()
        const breddValues = utforandeBreddValues[selectedValue] || { min: 0, max: 0 }
        modules.formValidator.validateBreddInput(breddInput, breddValues)
        updateAddToCartButtonState()
        updatePrice()
      })
    }

    // Setup validation for add to cart
    setupAddToCartValidation()

    // Setup number input maxlength enforcement
    setupNumberInputMaxlength()

    // Setup variation ID observer
    setupVariationObserver()
  }

  function setupAddToCartValidation() {
    const addToCartButton = document.querySelector('.single_add_to_cart_button')
    if (!addToCartButton) return

    // Filter null fields
    const requiredFields = [
      document.getElementById('tillagg_bredd'),
      document.getElementById('tillagg_hojd'),
      document.getElementById('total_height_field'),
      document.getElementById('opening_height_field'),
      document.getElementById('transom_height_field')
    ].filter((field) => field !== null)

    // Create error message element
    const messageElement = document.createElement('div')
    messageElement.textContent = 'Alla fält måste fyllas innan du lägger till i varukorgen.'
    messageElement.style.color = 'red'
    messageElement.style.marginBottom = '10px'
    messageElement.style.display = 'none'
    addToCartButton.parentNode.insertBefore(messageElement, addToCartButton)

    // Add click handler
    addToCartButton.addEventListener('click', function (event) {
      try {
        const breddInput = document.getElementById('tillagg_bredd')
        if (!breddInput) return

        const allFieldsFilled = modules.formValidator.validateFormFields(requiredFields)

        if (!allFieldsFilled) {
          event.preventDefault()
          messageElement.style.display = 'block'
          messageElement.textContent = 'Alla fält måste fyllas innan du lägger till i varukorgen.'
        } else {
          messageElement.style.display = 'none'
        }
      } catch (error) {
        console.error('Error in add to cart validation:', error)
      }
    })
  }

  function setupNumberInputMaxlength() {
    const numberInputs = document.querySelectorAll('input[type="number"][maxlength]')

    numberInputs.forEach((input) => {
      const maxDigits = parseInt(input.getAttribute('maxlength'), 10)

      input.addEventListener('input', function () {
        const value = this.value.toString()
        if (value.length > maxDigits) {
          this.value = value.slice(0, maxDigits)
        }
      })
    })
  }

  function setupVariationObserver() {
    const variationIdField = document.querySelector('.variation_id')

    if (variationIdField) {
      const observer = new MutationObserver(() => {
        updatePrice()
      })

      observer.observe(variationIdField, { attributes: true, attributeFilter: ['value'] })
    }

    // Also listen for form changes
    const variationsForm = document.querySelector('form.variations_form')
    if (variationsForm) {
      variationsForm.addEventListener('change', function (event) {
        const variationId = document.querySelector('.variation_id').value
        if (variationId) {
          updatePrice()
        }
      })
    }
  }

  // WC/Swatches replaces the entire .woocommerce-variation innerHTML on change, orphaning direct observers.
  // We observe the stable parent .woocommerce-variation.single_variation instead.
  // Disconnect before updatePrice() to prevent infinite loops from our own DOM writes.
  function setupPriceObserver() {
    const variationContainer = document.querySelector('.woocommerce-variation.single_variation')
    if (!variationContainer) return

    const observer = new MutationObserver(function () {
      observer.disconnect()
      updatePrice()
      observer.observe(variationContainer, { childList: true, subtree: true })
    })

    observer.observe(variationContainer, { childList: true, subtree: true })
  }

  function setInitialMinMax() {
    const tillaggHojd = document.getElementById('tillagg_hojd')
    const totalHeightField = document.getElementById('total_height_field')

    if (!totalHeightField || !tillaggHojd || !tillaggHojd.options || !tillaggHojd.selectedIndex) {
      return
    }

    const selectedTerm = tillaggHojd.options[tillaggHojd.selectedIndex]
    const min = parseFloat(selectedTerm.getAttribute('data-min'))
    const max = parseFloat(selectedTerm.getAttribute('data-max'))

    totalHeightField.min = min
    totalHeightField.max = max
    totalHeightField.placeholder = `Min: ${min} mm, Max: ${max} mm`
  }

  function updatePlaceholderAndValidate() {
    const tillaggHojd = document.getElementById('tillagg_hojd')
    const totalHeightField = document.getElementById('total_height_field')

    if (!tillaggHojd || !tillaggHojd.options || !tillaggHojd.selectedIndex || !totalHeightField) {
      return true
    }

    const selectedTerm = tillaggHojd.options[tillaggHojd.selectedIndex]
    const min = parseFloat(selectedTerm.getAttribute('data-min'))
    const max = parseFloat(selectedTerm.getAttribute('data-max'))

    totalHeightField.placeholder = `Min: ${min} mm, Max: ${max} mm`
    totalHeightField.min = min
    totalHeightField.max = max

    const totalHeightValue = parseFloat(totalHeightField.value)
    let errorMessage = document.getElementById('height-error-message')

    // Reset the input and error state
    totalHeightField.classList.remove('border-red-500')
    if (errorMessage) {
      errorMessage.remove()
    }

    // Check if the value is within range
    if (isNaN(totalHeightValue) || totalHeightValue < min || totalHeightValue > max) {
      totalHeightField.classList.add('border-red-500')

      if (!errorMessage && calculationType !== 'total_height') {
        errorMessage = document.createElement('div')
        errorMessage.id = 'height-error-message'

        if (totalHeightField.parentNode) {
          totalHeightField.parentNode.appendChild(errorMessage)
        }
      }

      if (errorMessage) {
        errorMessage.textContent = 'Höjden måste vara mellan ' + min + ' mm och ' + max + ' mm.'

        if (totalHeightField.parentNode && !totalHeightField.parentNode.contains(errorMessage)) {
          totalHeightField.parentNode.appendChild(errorMessage)
        }
      }

      return false
    }

    return true
  }

  function initializeCalculations() {
    if (calculationType === 'total_height') {
      updateTotalHeight()
    } else if (calculationType === 'opening_height') {
      updateHeights()
    } else if (calculationType === 'opening_height_split') {
      updateSplitHeights()
    } else if (calculationType === 'fast_racke') {
      updatePrice()
    }

    // Additional setup for fast_racke
    if (calculationType === 'fast_racke') {
      const breddInput = document.getElementById('tillagg_bredd')
      const hojdInput = document.getElementById('tillagg_hojd')

      if (breddInput) {
        breddInput.addEventListener('input', updatePrice)
      }

      if (hojdInput) {
        hojdInput.addEventListener('input', updatePrice)
      }
    }
  }

  // Public API
  return {
    init: init,
    initialize: initialize,
    updatePrice: updatePrice,
    updateHeights: updateHeights,
    updateSplitHeights: updateSplitHeights,
    updateTotalHeight: updateTotalHeight,
    updateAddToCartButtonState: updateAddToCartButtonState
  }
})()

export { UIManager }
